import React from 'react';

export const PL_FLAG_SVG = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="cab-flag-icon">
    <circle cx="10" cy="10" r="10" fill="#F0F0F0"/>
    <path d="M0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10H0Z" fill="#D22730"/>
  </svg>
);

export interface Country {
  code: string;
  dialCode: string;
  name: string;
  flagNode: React.ReactNode;
}

export const COUNTRIES: Country[] = [
  // --- Пріоритетні країни ---
  { code: 'PL', dialCode: '+48',  name: 'Polska',    flagNode: PL_FLAG_SVG },
  { code: 'UA', dialCode: '+380', name: 'Ukraina',   flagNode: <span className="cab-flag-emoji">🇺🇦</span> },
  { code: 'DE', dialCode: '+49',  name: 'Niemcy',    flagNode: <span className="cab-flag-emoji">🇩🇪</span> },
  { code: 'BY', dialCode: '+375', name: 'Białoruś',  flagNode: <span className="cab-flag-emoji">🇧🇾</span> },
  // --- Решта в алфавітному порядку ---
  { code: 'AL', dialCode: '+355', name: 'Albania',             flagNode: <span className="cab-flag-emoji">🇦🇱</span> },
  { code: 'AD', dialCode: '+376', name: 'Andora',              flagNode: <span className="cab-flag-emoji">🇦🇩</span> },
  { code: 'AT', dialCode: '+43',  name: 'Austria',             flagNode: <span className="cab-flag-emoji">🇦🇹</span> },
  { code: 'BE', dialCode: '+32',  name: 'Belgia',              flagNode: <span className="cab-flag-emoji">🇧🇪</span> },
  { code: 'BA', dialCode: '+387', name: 'Bośnia i Hercegowina',flagNode: <span className="cab-flag-emoji">🇧🇦</span> },
  { code: 'BG', dialCode: '+359', name: 'Bułgaria',            flagNode: <span className="cab-flag-emoji">🇧🇬</span> },
  { code: 'HR', dialCode: '+385', name: 'Chorwacja',           flagNode: <span className="cab-flag-emoji">🇭🇷</span> },
  { code: 'CY', dialCode: '+357', name: 'Cypr',                flagNode: <span className="cab-flag-emoji">🇨🇾</span> },
  { code: 'ME', dialCode: '+382', name: 'Czarnogóra',          flagNode: <span className="cab-flag-emoji">🇲🇪</span> },
  { code: 'CZ', dialCode: '+420', name: 'Czechy',              flagNode: <span className="cab-flag-emoji">🇨🇿</span> },
  { code: 'DK', dialCode: '+45',  name: 'Dania',               flagNode: <span className="cab-flag-emoji">🇩🇰</span> },
  { code: 'EE', dialCode: '+372', name: 'Estonia',             flagNode: <span className="cab-flag-emoji">🇪🇪</span> },
  { code: 'FI', dialCode: '+358', name: 'Finlandia',           flagNode: <span className="cab-flag-emoji">🇫🇮</span> },
  { code: 'FR', dialCode: '+33',  name: 'Francja',             flagNode: <span className="cab-flag-emoji">🇫🇷</span> },
  { code: 'GR', dialCode: '+30',  name: 'Grecja',              flagNode: <span className="cab-flag-emoji">🇬🇷</span> },
  { code: 'ES', dialCode: '+34',  name: 'Hiszpania',           flagNode: <span className="cab-flag-emoji">🇪🇸</span> },
  { code: 'NL', dialCode: '+31',  name: 'Holandia',            flagNode: <span className="cab-flag-emoji">🇳🇱</span> },
  { code: 'IE', dialCode: '+353', name: 'Irlandia',            flagNode: <span className="cab-flag-emoji">🇮🇪</span> },
  { code: 'IS', dialCode: '+354', name: 'Islandia',            flagNode: <span className="cab-flag-emoji">🇮🇸</span> },
  { code: 'LI', dialCode: '+423', name: 'Liechtenstein',       flagNode: <span className="cab-flag-emoji">🇱🇮</span> },
  { code: 'LT', dialCode: '+370', name: 'Litwa',               flagNode: <span className="cab-flag-emoji">🇱🇹</span> },
  { code: 'LU', dialCode: '+352', name: 'Luksemburg',          flagNode: <span className="cab-flag-emoji">🇱🇺</span> },
  { code: 'LV', dialCode: '+371', name: 'Łotwa',               flagNode: <span className="cab-flag-emoji">🇱🇻</span> },
  { code: 'MK', dialCode: '+389', name: 'Macedonia Północna',  flagNode: <span className="cab-flag-emoji">🇲🇰</span> },
  { code: 'MT', dialCode: '+356', name: 'Malta',               flagNode: <span className="cab-flag-emoji">🇲🇹</span> },
  { code: 'MD', dialCode: '+373', name: 'Mołdawia',            flagNode: <span className="cab-flag-emoji">🇲🇩</span> },
  { code: 'MC', dialCode: '+377', name: 'Monako',              flagNode: <span className="cab-flag-emoji">🇲🇨</span> },
  { code: 'NO', dialCode: '+47',  name: 'Norwegia',            flagNode: <span className="cab-flag-emoji">🇳🇴</span> },
  { code: 'PT', dialCode: '+351', name: 'Portugalia',          flagNode: <span className="cab-flag-emoji">🇵🇹</span> },
  { code: 'RO', dialCode: '+40',  name: 'Rumunia',             flagNode: <span className="cab-flag-emoji">🇷🇴</span> },
  { code: 'SM', dialCode: '+378', name: 'San Marino',          flagNode: <span className="cab-flag-emoji">🇸🇲</span> },
  { code: 'RS', dialCode: '+381', name: 'Serbia',              flagNode: <span className="cab-flag-emoji">🇷🇸</span> },
  { code: 'SK', dialCode: '+421', name: 'Słowacja',            flagNode: <span className="cab-flag-emoji">🇸🇰</span> },
  { code: 'SI', dialCode: '+386', name: 'Słowenia',            flagNode: <span className="cab-flag-emoji">🇸🇮</span> },
  { code: 'CH', dialCode: '+41',  name: 'Szwajcaria',          flagNode: <span className="cab-flag-emoji">🇨🇭</span> },
  { code: 'SE', dialCode: '+46',  name: 'Szwecja',             flagNode: <span className="cab-flag-emoji">🇸🇪</span> },
  { code: 'VA', dialCode: '+379', name: 'Watykan',             flagNode: <span className="cab-flag-emoji">🇻🇦</span> },
  { code: 'HU', dialCode: '+36',  name: 'Węgry',               flagNode: <span className="cab-flag-emoji">🇭🇺</span> },
  { code: 'GB', dialCode: '+44',  name: 'Wielka Brytania',     flagNode: <span className="cab-flag-emoji">🇬🇧</span> },
  { code: 'IT', dialCode: '+39',  name: 'Włochy',              flagNode: <span className="cab-flag-emoji">🇮🇹</span> },
];


export const getCountryName = (code: string, lang: string, defaultName: string) => {
  const map: Record<string, Record<string, string>> = {
    'PL': { uk: 'Польща', ru: 'Польша' },
    'UA': { uk: 'Україна', ru: 'Украина' },
    'DE': { uk: 'Німеччина', ru: 'Германия' },
    'BY': { uk: 'Білорусь', ru: 'Беларусь' },
    'AL': { uk: 'Албанія', ru: 'Албания' },
    'AD': { uk: 'Андорра', ru: 'Андорра' },
    'AT': { uk: 'Австрія', ru: 'Австрия' },
    'BE': { uk: 'Бельгія', ru: 'Бельгия' },
    'BA': { uk: 'Боснія і Герцеговина', ru: 'Босния и Герцеговина' },
    'BG': { uk: 'Болгарія', ru: 'Болгария' },
    'HR': { uk: 'Хорватія', ru: 'Хорватия' },
    'CY': { uk: 'Кіпр', ru: 'Кипр' },
    'ME': { uk: 'Чорногорія', ru: 'Черногория' },
    'CZ': { uk: 'Чехія', ru: 'Чехия' },
    'DK': { uk: 'Данія', ru: 'Дания' },
    'EE': { uk: 'Естонія', ru: 'Эстония' },
    'FI': { uk: 'Фінляндія', ru: 'Финляндия' },
    'FR': { uk: 'Франція', ru: 'Франция' },
    'GR': { uk: 'Греція', ru: 'Греция' },
    'ES': { uk: 'Іспанія', ru: 'Испания' },
    'NL': { uk: 'Нідерланди', ru: 'Нидерланды' },
    'IE': { uk: 'Ірландія', ru: 'Ирландия' },
    'IS': { uk: 'Ісландія', ru: 'Исландия' },
    'LI': { uk: 'Ліхтенштейн', ru: 'Лихтенштейн' },
    'LT': { uk: 'Литва', ru: 'Литва' },
    'LU': { uk: 'Люксембург', ru: 'Люксембург' },
    'LV': { uk: 'Латвія', ru: 'Латвия' },
    'MK': { uk: 'Північна Македонія', ru: 'Северная Македония' },
    'MT': { uk: 'Мальта', ru: 'Мальта' },
    'MD': { uk: 'Молдова', ru: 'Молдова' },
    'MC': { uk: 'Монако', ru: 'Монако' },
    'NO': { uk: 'Норвегія', ru: 'Норвегия' },
    'PT': { uk: 'Португалія', ru: 'Португалия' },
    'RO': { uk: 'Румунія', ru: 'Румыния' },
    'SM': { uk: 'Сан-Марино', ru: 'Сан-Марино' },
    'RS': { uk: 'Сербія', ru: 'Сербия' },
    'SK': { uk: 'Словаччина', ru: 'Словакия' },
    'SI': { uk: 'Словенія', ru: 'Словения' },
    'CH': { uk: 'Швейцарія', ru: 'Швейцария' },
    'SE': { uk: 'Швеція', ru: 'Швеция' },
    'VA': { uk: 'Ватикан', ru: 'Ватикан' },
    'HU': { uk: 'Угорщина', ru: 'Венгрия' },
    'GB': { uk: 'Великобританія', ru: 'Великобритания' },
    'IT': { uk: 'Італія', ru: 'Италия' }
  };
  return map[code]?.[lang] || defaultName;
};
